import * as React from "react";

import "./deny-success-modal.scss";

import {cs}           from "@Common/react/chain-services";
import {DeprecatedModalService2} from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";

export const DenySuccessModal = ({onClose=undefined, next: rootNext}) => cs(
    ["modal", ({}, next) => <DeprecatedModalService2 {...{
        render: ({id, email, type}, rm) => ({
            size: "small",
            content: next({
                close: () => rm(),
                id,
                email,
                type,
            }),
        }),
        hideCloseButton: true,
        onPassiveClose: ()=> {onClose()},       
        next: rootNext,
    }}/>],

    ({modal}) => (
        <div className="deny-success-modal-02e" xd-qa-type="modal" xd-qa-name="deny success modal">
            <div className="message" xd-qa-type="label" xd-qa-name="deny success message">
                Access to {modal.type} {modal.id} has been given back to the user.
            </div>


            <div className="footer">
                <button {...{
                    className: "close",
                    onClick: async () => {
                        onClose && onClose();
                        modal.close();
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "close",
                }}>
                    Close
                </button>
                <a className="email" href={`mailto:${modal.email}?subject=${encodeURIComponent(`Approval for ${modal.type} ${modal.id}`)}`} xd-qa-type="link" xd-qa-name="Open email client">Open email to client</a>
            </div>
        </div>
    )
);